<div class="lm-builder-preview-banner-text-container form-layout-compact ">
    <div class="field">
        <label [required]="titleRequired" soho-label for="lm-builder-list-title">{{ 'ReportName' | translate }}</label>
        <input
                id="lm-builder-list-title"
                data-automation-id="lm-builder-list-title-input"
                soho-input
                soho-trackdirty
                data-validate="validateTitle"
                [(ngModel)]="this.title"
                (ngModelChange)="updateTitle()">
    </div>

    @if(listSpec) {
        <div class="field">
            <label soho-label for="lm-builder-list-title"></label>
            <p class="lm-font-md">{{ 'PreviewOnlyActionsNotAvailable' | translate }}</p>
        </div>
    }

    @if (showDebug) {
        <div class="field">
            <label [required]="titleRequired" soho-label for="lm-builder-list-title">Debug</label>
            <select
                    class="input-sm"
                    soho-dropdown
                    soho-trackdirty
                    id="lm-builder-preview-option"
                    name="lm-builder-preview-option"
                    [(ngModel)]="displayOption">
                <option [value]="'list'">List</option>
                <option [value]="'lpl'">LPL</option>
                @if (this.userFolderJson) {
                    <option [value]="'userFolder'">User Folder</option>
                }
            </select>
        </div>
    }
</div>
@if(listSpec && displayOption === "list" && listSpec?.busListSpec?.displayFields.length > 0) {
    <div class="lm-builder preview">
        <lm-list
            [previewMode] = true
            [listUrlInfo]="listUrlInfo"
            [listSpec]="listSpec"
            [overrideListTitle]="listTitleOverride"
            [modelLpl]="lpl"
            [modelUserFolder]="spec.userFolder"
        ></lm-list>
    </div>
} @else if (displayOption === "lpl") {
    <p class="lm-builder-preview-spec">{{ lpl }}</p>
} @else if (displayOption === "userFolder") {
    <p class="lm-builder-preview-spec">{{ userFolderJson }}</p>
} @else {
    <div
        cdkDropList
        cdkDropList
        [id]="LMBuilderModel.LIST_PREVIEW_EMPTY_STATE"
        [cdkDropListConnectedTo]="[LMBuilderModel.FACADE_FIELD_PICKER_FIELDS_LIST]"
        [cdkDropListData]="LMBuilderModel.DISPLAY_FIELDS_LIST"
        [cdkDropListEnterPredicate]="canDrop"
        (cdkDropListDropped)="drop($event)"
        class="lm-builder-empty-message-container">
    <div soho-emptymessage
         [title]="'AddColumnsToYourReport' | translate"
         [info]="'AddFieldsByDraggingMessage' | translate"
         [icon]="'icon-empty-new-project-new'"></div>
    </div>
}
